import { postJSON } from 'common/services/api'
import dayjs from 'dayjs'
import { useMutation } from 'react-query'
import { YEAR_FIRST_DATE_FORMAT } from '../utils.datetime'
import { ROTA_GENERATED_QUERY_KEY, ROTA_GENERATED_URL } from './queryConstants'

export type GeneratedRota = {
  patternStartDate: string
  patternEndDate?: string
}

type UseRotaGeneratedReturn = {
  checkRotaGenerated: (values: GeneratedRota) => Promise<unknown>
  isLoading: boolean
}

const useRotaGenerated = (): UseRotaGeneratedReturn => {
  const createFunction = async (values: GeneratedRota) => {
    const startDate = dayjs(values.patternStartDate).format(
      YEAR_FIRST_DATE_FORMAT
    )
    const endDate = values.patternEndDate
      ? dayjs(values.patternEndDate).format(YEAR_FIRST_DATE_FORMAT)
      : undefined

    return postJSON({
      url: ROTA_GENERATED_URL,
      method: 'POST',
      json: { startDate, endDate },
      isRota: true
    })
  }

  const { mutateAsync: createMutation, isLoading } = useMutation<
    unknown,
    unknown,
    GeneratedRota,
    unknown
  >([ROTA_GENERATED_QUERY_KEY], createFunction)

  const checkRotaGenerated = async (values: GeneratedRota) => {
    try {
      const result = await createMutation(values)
      return result
    } catch (err) {
      return false
    }
  }

  return {
    checkRotaGenerated,
    isLoading
  }
}

export default useRotaGenerated
